import React from "react";

export interface FolderIconProps {
  withDocuments?: boolean;
}

const FolderIcon = React.forwardRef(
  (
    {
      withDocuments = false,
      ...props
    }: React.SVGProps<SVGSVGElement> & FolderIconProps,
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <defs>
        <filter
          x="-14.9%"
          y="-112.5%"
          width="129.8%"
          height="275%"
          filterUnits="objectBoundingBox"
          id="image_svg__a"
        >
          <feOffset dy={-2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation={2}
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path id="image_svg__b" d="M4 28h47v8H4z" />
      </defs>
      <g fillRule="evenodd">
        <path
          d="M90 20H50L40 10H10C4.45 10 0 14.45 0 20v60c0 5.523 4.477 10 10 10h80c5.523 0 10-4.477 10-10V30c0-5.55-4.5-10-10-10z"
          fill="#32178B"
        />
        {withDocuments ? (
          <path d="M8 20h42v9H4v-5a4 4 0 014-4z" fill="#FFFFFF" />
        ) : null}
        <use
          filter="url(#image_svg__a)"
          xlinkHref="#image_svg__b"
          fill="black"
        />
        <use xlinkHref="#image_svg__b" fill="#D8D8D8" />
        <path
          d="M90 20H50l-10 8H5a5 5 0 00-5 5v47c0 5.523 4.477 10 10 10h80c5.523 0 10-4.477 10-10V30c0-5.55-4.5-10-10-10z"
          fill="#5D2BFF"
        />
      </g>
    </svg>
  )
);

FolderIcon.displayName = "FolderIcon";
export default FolderIcon;
